import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GoogleSignInButton from '../components/GoogleSignInButton';

const C = { primary: '#8B1A1A', gold: '#D4A017' };

const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  border: '1.5px solid #e0d0d0',
  borderRadius: 4,
  fontSize: 14,
  outline: 'none',
  fontFamily: 'Lato, sans-serif',
};

export default function Login() {
  const navigate = useNavigate();
  const { login, googleLogin } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch {
      setError('Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleCredential = async (credential) => {
    setError('');
    await googleLogin(credential);
    navigate('/');
  };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 10, padding: '48px 40px', width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(139,26,26,0.1)' }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 28, color: '#2C2C2C', textAlign: 'center', marginBottom: 8 }}>Welcome Back</h1>
        <p style={{ textAlign: 'center', color: '#888', marginBottom: 32, fontSize: 14 }}>Sign in to your A1 Looks account</p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 6 }}>Username</label>
            <input style={inputStyle} name="username" value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))} required autoFocus />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 6 }}>Password</label>
            <input style={inputStyle} type="password" name="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
          </div>

          {error && <p style={{ color: '#e53935', fontSize: 13, marginBottom: 16, textAlign: 'center' }}>{error}</p>}

          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '13px', background: loading ? '#ccc' : C.primary, color: '#fff', border: 'none', borderRadius: 4, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        {process.env.REACT_APP_GOOGLE_CLIENT_ID && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '24px 0' }}>
              <span style={{ flex: 1, height: 1, background: '#eadede' }} />
              <span style={{ color: '#999', fontSize: 12, textTransform: 'uppercase' }}>or</span>
              <span style={{ flex: 1, height: 1, background: '#eadede' }} />
            </div>
            <GoogleSignInButton
              onCredential={handleGoogleCredential}
              onError={setError}
            />
          </>
        )}

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#666' }}>
          Don't have an account?{' '}
          <Link to="/register" style={{ color: C.primary, fontWeight: 600, textDecoration: 'none' }}>Create one</Link>
        </p>
      </div>
    </div>
  );
}
